import React from "react";
import {Link} from "react-router-dom";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import {message, Popconfirm, Space, Tag} from "antd";
import * as api from '../../apis/returnOrder'
import dayjs from "dayjs";
import {useRequest} from "ahooks";

function RefundOrder(props: any) {

    const {tableProps, form, search, refresh} = useAntTable(api.getReturnOrderList, {method: "post"});

    const {run} = useRequest(api.updateReturnOrderContacted, {
        manual: true,
        onSuccess: () => {
            message.success('更新成功')
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: '退货单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'orderDate',
            title: '订单日期',
            render: (value: any) => dayjs(value).format('ll')
        },
        {
            dataIndex: 'orderTotalAmount',
            title: '订单合计'
        },
        {
            dataIndex: 'contacted',
            title: '已联系',
            render: (value: boolean) => value ? <Tag color={"green"}>已联系</Tag> : <Tag color={"orange"}>未联系</Tag>
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(_, record: any) {
                return <Space>
                    <Link to={`/order/return/detail/${record.id}`}>详情</Link>
                    <a>日志</a>
                    {!record.contacted && <Popconfirm
                        title={'确认已联系'}
                        onConfirm={() => run(record.id)}
                    >
                        <a>联系</a>
                    </Popconfirm>}
                </Space>
            }
        }
    ];
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'orderCode',
            title: '退货单号',
            search: true
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'orderDate',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        },
    ];

    return <PageHeaderLayout>
        <StandardTable columns={columns} extSearchColumns={searchColumns} {...tableProps} form={form} search={search}/>
    </PageHeaderLayout>
}

export default RefundOrder;